import { HttpApiService } from "@/shared/services/httpApi.service";

import { NOTES_API_ENDPOINTS } from "../constants/news.constants";
import type {
  NotesListResponse,
  CreateNoteRequest,
  NoteItem,
  NoteByIdPayload,
} from "../types/notes-api.types";

export interface FetchNotesParams {
  skip?: number;
  limit?: number;
  status?: string;
  search?: string;
}

export const notesService = {
  fetchList: async (params?: FetchNotesParams): Promise<NotesListResponse> => {
    const path = NOTES_API_ENDPOINTS.NOTES;
    const queryParams: string[] = [];
    if (params?.skip != null) queryParams.push(`skip=${params.skip}`);
    if (params?.limit != null) queryParams.push(`limit=${params.limit}`);
    if (params?.status) queryParams.push(`status=${encodeURIComponent(params.status)}`);
    if (params?.search != null && params.search.trim() !== "")
      queryParams.push(`search=${encodeURIComponent(params.search.trim())}`);
    const url = queryParams.length ? `${path}?${queryParams.join("&")}` : path;
    const response = await HttpApiService.get<NotesListResponse>(url);
    return response.data;
  },

  fetchById: async (id: string): Promise<NoteByIdPayload> => {
    const path = NOTES_API_ENDPOINTS.noteById(id);
    const response = await HttpApiService.get<NoteByIdPayload>(path);
    return response.data;
  },

  create: async (data: CreateNoteRequest, attachments?: File[] | null): Promise<NoteItem> => {
    const body: CreateNoteRequest = {
      ...data,
      is_pinned: data.is_pinned ?? false,
      status: data.status ?? "ACTIVE",
    };
    const response = await HttpApiService.post<NoteItem, CreateNoteRequest>(NOTES_API_ENDPOINTS.NOTES, body);
    const created = response.data;

    const files = attachments ?? [];
    if (files.length === 0) {
      return created;
    }

    let latest: NoteItem = created;
    for (const file of files) {
      const formData = new FormData();
      formData.append("attachment", file, file.name);
      const uploadResponse = await HttpApiService.post<NoteItem, FormData>(
        NOTES_API_ENDPOINTS.noteAttachment(created.id),
        formData,
      );
      latest = uploadResponse.data;
    }
    return latest;
  },

  delete: async (id: string): Promise<void> => {
    await HttpApiService.delete(`${NOTES_API_ENDPOINTS.NOTES}/${id}`);
  },
};
